// utils/e2eeRecovery.js
//import { generateMnemonic } from 'bip39';

// ✅ Utilisez l'API Web Crypto (disponible dans tous les navigateurs modernes)
const crypto = window.crypto || window.msCrypto; // Polyfill pour IE


export async function encryptPrivateKey(privateKey, recoveryPhrase) {
  const salt = crypto.getRandomValues(new Uint8Array(16));

  const keyMaterial = await crypto.subtle.importKey(
    'raw',
    new TextEncoder().encode(recoveryPhrase),
    { name: 'PBKDF2' },
    false,
    ['deriveKey']
  );

  const derivedKey = await crypto.subtle.deriveKey(
    {
      name: 'PBKDF2',
      salt,
      iterations: 100000,
      hash: 'SHA-256'
    },
    keyMaterial,
    { name: 'AES-GCM', length: 256 },
    false,
    ['encrypt', 'decrypt']
  );

  const iv = crypto.getRandomValues(new Uint8Array(12));

  const payload = JSON.stringify({
  identityKey: {
    privKey: Array.from(new Uint8Array(privateKey.identityKey.privKey)),
    pubKey: Array.from(new Uint8Array(privateKey.identityKey.pubKey)),
  },

  registrationId: privateKey.registrationId,

  signedPreKey: {
    keyId: privateKey.signedPreKey.keyId,

    keyPair: {
      privKey: Array.from(
        new Uint8Array(privateKey.signedPreKey.keyPair.privKey)
      ),
      pubKey: Array.from(
        new Uint8Array(privateKey.signedPreKey.keyPair.pubKey)
      ),
    },

    signature: Array.from(
      new Uint8Array(privateKey.signedPreKey.signature)
    ),
  },
});

const encrypted = await crypto.subtle.encrypt(
  {
    name: 'AES-GCM',
    iv
  },
  derivedKey,
  new TextEncoder().encode(payload)
);

  //const phraseHash = await crypto.subtle.digest(
  //  'SHA-256',
  //  new TextEncoder().encode(recoveryPhrase)
 // );

  return {
    encryptedPrivateKey: arrayBufferToBase64(encrypted),
    iv: arrayBufferToBase64(iv),
    salt: arrayBufferToBase64(salt),
    //phraseHash: arrayBufferToBase64(phraseHash)
  };
}
// Helper: Convertir ArrayBuffer en Base64
function arrayBufferToBase64(buffer) {
  return btoa(String.fromCharCode(...new Uint8Array(buffer)));
}

export async function recoverPrivateKey(recoveryPhrase, encryptedData) {
  

  const keyMaterial = await crypto.subtle.importKey(
    'raw',
    new TextEncoder().encode(recoveryPhrase),
    { name: 'PBKDF2' },
    false,
    ['deriveKey']
  );

  const derivedKey = await crypto.subtle.deriveKey(
    {
      name: 'PBKDF2',
      salt: base64ToArrayBuffer(encryptedData.salt),
      iterations: 100000,
      hash: 'SHA-256'
    },
    keyMaterial,
    { name: 'AES-GCM', length: 256 },
    false,
    ['decrypt']
  );

let decrypted;
try {
  decrypted = await crypto.subtle.decrypt(
    { name: 'AES-GCM', iv: base64ToArrayBuffer(encryptedData.iv) },
    derivedKey,
    base64ToArrayBuffer(encryptedData.encryptedPrivateKey)
  );
} catch {
  throw new Error('Phrase de récupération invalide');
}
  //const decrypted = await crypto.subtle.decrypt(
  //  {
   //   name: 'AES-GCM',
  //    iv: base64ToArrayBuffer(encryptedData.iv)
   // },
  //  derivedKey,
  //  base64ToArrayBuffer(encryptedData.encryptedPrivateKey)
  //);

  // 🔐 Le nouveau backup contient un objet JSON complet
  const payload = new TextDecoder().decode(decrypted);

  const recoveredState = JSON.parse(payload);

  return {
    identityKey: {
      privKey: new Uint8Array(
        recoveredState.identityKey.privKey
      ).buffer,

      pubKey: new Uint8Array(
        recoveredState.identityKey.pubKey
      ).buffer,
    },

    registrationId: recoveredState.registrationId,

    signedPreKey: {
      keyId: recoveredState.signedPreKey.keyId,

      keyPair: {
        privKey: new Uint8Array(
          recoveredState.signedPreKey.keyPair.privKey
        ).buffer,

        pubKey: new Uint8Array(
          recoveredState.signedPreKey.keyPair.pubKey
        ).buffer,
      },

      signature: new Uint8Array(
        recoveredState.signedPreKey.signature
      ).buffer,
    },
  };
}

// Helper: Convertir Base64 en ArrayBuffer
function base64ToArrayBuffer(base64) {
  const binaryString = atob(base64);
  const bytes = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes.buffer;
}